module.exports = __webpack_public_path__ + "img/2022-12-03_13-35-09.b7045538.jpg";